/* src/components/pages/Registrarcliente.jsx - Última MOdificación: 07-01-2026 */
/* -------------------- Modal para registrar cliente nuevo ------------------- */

import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Button, TextField, Box, Modal, Typography, Divider, MenuItem, alpha,
  Checkbox, FormControl, FormControlLabel, Select, FormHelperText } from '@mui/material';

import api from '../../services/api.js'; // Api Interceptor en vez de Axios
  
import Link from '@mui/material/Link';
import { RiSave3Fill, RiReplyAllLine, RiVideoFill } from "react-icons/ri";

import { useFeedback } from '../../context/FeedbackContext'; // Mensajes breves


const Registrarcliente = ({ uniqueId, onClose, onSuccess }) => {
  const { showFeedback } = useFeedback(); // Mensaje breve

  const [open, setOpen] = useState(true); // modal empieza abierto cuando se montas
  const rutInputRef = useRef(null); // 👉 referencia al campo Rut

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState(''); // Para mostrar el mensaje de error cliente ya existe //

  const [rutCli, setRutCli] = useState('');
  const [nombreCli, setNombreCli] = useState('');
  const [direccionCli, setDireccionCli] = useState('');
  const [comunaCli, setComunaCli] = useState('');
  const [ciudadCli, setCiudadCli] = useState('');
  const [telefonoCli, setTelefonoCli] = useState('');
  const [emailCli, setEmailCli] = useState('');
  const [clavesiiCli, setClavesiiCli] = useState('');
  const [claveunicaCli, setClaveunicaCli] = useState('');
  const [banco1Cli, setBanco1Cli] = useState('');
  const [banco2Cli, setBanco2Cli] = useState('');
  const [banco3Cli, setBanco3Cli] = useState('');
  const [ctacte1Cli, setCtacte1Cli] = useState('');
  const [ctacte2Cli, setCtacte2Cli] = useState('');
  const [ctacte3Cli, setCtacte3Cli] = useState('');

  const [bancos, setBancos] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);
  
  /* control de términos y condiciones */
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [openTerms, setOpenTerms] = useState(false);

  /* Estilo */
  const inputSx = {
    mt: 0.75,

    '& .MuiInputBase-root': {
      height: 38,
      fontSize: '0.84rem',
      borderRadius: 2,
      backdropFilter: 'blur(8px)',
    },

    '& .MuiOutlinedInput-input': {
      padding: '9px 12px',
    },

    '& .MuiInputLabel-root': {
      fontSize: '0.83rem',
      top: -7,
    },

    '& .MuiInputLabel-shrink': {
      top: 0,
    },

    '& .MuiFormHelperText-root': {
      marginLeft: 0,
      minHeight: 16,
      fontSize: '0.72rem',
      lineHeight: 1.1,
    },
  };

  /* Validación de formato de email */
  const validarEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  /* cargar bancos desde tabla bancos */
  const fetchBancos = useCallback(async () => {
    try {

      const response = await api.post('/registrarse/getbancos', {
        idBan: 0
      });

      if (response.data.success && response.data.rows) {
        setBancos(response.data.rows); // Asigna los datos al estado //
      } else {
        setBancos([]); // Si no hay datos, asegúrate de limpiar el estado //
      }

    } catch (error) {
      setBancos([]); // Si no hay datos, asegúrate de limpiar el estado //
    }
  }, []);

  /* carga los bancos */
  useEffect(() => {
    fetchBancos();
  }, [fetchBancos]);

  /* Validar bancos y ctasctes */
  const validateBankPair = (banco, cuenta, idx, newErrors) => {
    const bancoKey = `banco${idx}Cli`;
    const cuentaKey = `ctacte${idx}Cli`;

    newErrors[bancoKey] = '';
    newErrors[cuentaKey] = '';

    const cuentaValida = cuenta && cuenta.trim() !== '';
    const bancoValido = banco

    if (bancoValido && !cuentaValida) {
      newErrors[cuentaKey] = `Debe ingresar la Ctacte ${idx}`;
    } else if (!bancoValido && cuentaValida) {
      newErrors[bancoKey] = `Debe seleccionar el Banco ${idx}`;
    }
  };

  /* Manejo de cambio y validaciones de input */
  const handleInputChange = async (e, fieldName) => {
    const { value } = e.target;
    let newErrors = { ...errors };

    switch (fieldName) {

      case 'rutCli': {
        setRutCli(value);
        newErrors.rutCli = '';

        const cleanRut = normalizeRut(value);

        // vacío
        if (!cleanRut) {
          newErrors.rutCli = 'El Rut es obligatorio';
          setErrors(newErrors);
          break;
        }

        // todavía escribiendo
        if (cleanRut.length < 10) {
          setErrors(newErrors);
          break;
        }

        // recién aquí validar módulo 11
        if (!validarRut(cleanRut)) {
          newErrors.rutCli = 'El Rut Empresa no es válido';
          setErrors(newErrors);
          break;
        } else {
          const fixRutCli = normalizeRut(value);
          const rutExists = await checkRutExists(fixRutCli);
          if (rutExists) {
            newErrors.rutCli = 'El Rut Empresa ya existe';
            setErrors(newErrors);
          }
        }
        break;
      }

      case 'nombreCli':
        setNombreCli(value);
        newErrors.nombreCli = value.trim() === '' ? 'Debe ingresar el nombre' : '';
        break;
  
      case 'direccionCli':
        setDireccionCli(value);
        newErrors.direccionCli = value.trim() === '' ? 'Debe ingresar la dirección' : '';
        break;

      case 'comunaCli':
        setComunaCli(value);
        newErrors.comunaCli = value.trim() === '' ? 'Debe ingresar la comuna' : '';
        break;

      case 'ciudadCli':
        setCiudadCli(value);
        newErrors.ciudadCli = value.trim() === '' ? 'Debe ingresar la ciudad' : '';
        break;

      case 'telefonoCli':
        setTelefonoCli(value);
        newErrors.telefonoCli = value.trim() === '' ? 'Debe ingresar el teléfono' : '';
        break;

      case 'emailCli':
        setEmailCli(value);
        newErrors.emailCli =
          value.trim() === '' || !validarEmail(value) ? 'El email ingresado no es válido' : '';
        break;

      case 'clavesiiCli':
        setClavesiiCli(value);
        newErrors.clavesiiCli = value.trim() === '' ? 'Debe ingresar la clave del SII' : '';
        break;

      case 'claveunicaCli':
        setClaveunicaCli(value);
        newErrors.claveunicaCli = '';
        break;

      // ---------- Bancos y Ctacte ----------
      case 'banco1Cli':
        setBanco1Cli(value);
        break;
      case 'ctacte1Cli':
        setCtacte1Cli(value);
        break;
      case 'banco2Cli':
        setBanco2Cli(value);
        break;
      case 'ctacte2Cli':
        setCtacte2Cli(value);
        break;
      case 'banco3Cli':
        setBanco3Cli(value);
        break;
      case 'ctacte3Cli':
        setCtacte3Cli(value);
        break;

      default:
        break;
    }

    // Validación bancos/cuentas con valores actualizados
    validateBankPair(
      fieldName === 'banco1Cli' ? value : banco1Cli,
      fieldName === 'ctacte1Cli' ? value : ctacte1Cli,
      1,
      newErrors
    );

    validateBankPair(
      fieldName === 'banco2Cli' ? value : banco2Cli,
      fieldName === 'ctacte2Cli' ? value : ctacte2Cli,
      2,
      newErrors
    );

    validateBankPair(
      fieldName === 'banco3Cli' ? value : banco3Cli,
      fieldName === 'ctacte3Cli' ? value : ctacte3Cli,
      3,
      newErrors
    );

    // Validación global
    const hasErrors = Object.values(newErrors).some(err => err && err !== '');
    const requiredFields = [
      rutCli,
      fieldName === 'nombreCli' ? value : nombreCli,
      fieldName === 'direccionCli' ? value : direccionCli,
      fieldName === 'comunaCli' ? value : comunaCli,
      fieldName === 'ciudadCli' ? value : ciudadCli,
      telefonoCli,
      emailCli,
      fieldName === 'clavesiiCli' ? value : clavesiiCli
    ];
    const hasEmptyFields = requiredFields.some(field => !field || field.trim() === '');

    setErrors(newErrors);
    setIsFormValid(!hasErrors && !hasEmptyFields);
  };

  /* Validación del Rut (Módulo 11) */
  const validarRut = (rut) => {
    let valor = rut.replace(/\./g, '').replace('-', '');
    let cuerpo = valor.slice(0, -1);
    let dv = valor.slice(-1).toUpperCase();
    let suma = 0;
    let multiplo = 2;

    for (let i = 1; i <= cuerpo.length; i++) {
      let index = multiplo * valor.charAt(cuerpo.length - i);
      suma += index;
      multiplo = multiplo < 7 ? multiplo + 1 : 2;
    }

    let dvEsperado = 11 - (suma % 11);
    dvEsperado = dvEsperado === 11 ? '0' : dvEsperado === 10 ? 'K' : dvEsperado.toString();
    return dv === dvEsperado;
  };

  const normalizeRut = (rut = '') => {

    const clean = rut
      .replace(/\./g, '')
      .replace(/-/g, '')
      .trim()
      .toUpperCase();

    // evitar errores mientras escribe
    if (clean.length < 2) {
      return clean;
    }

    // separar cuerpo y dv
    const cuerpo = clean.slice(0, -1);
    const dv = clean.slice(-1);

    // cuerpo a largo 9
    const cuerpoPadded = cuerpo.padStart(9, '0');

    // total largo 10
    return `${cuerpoPadded}${dv}`;
  };


  /* Verificar si el RUT ya existe en la base de datos */
  const checkRutExists = async (rut) => {
    try {
      setMessage('');

      const RutCli = normalizeRut(rut);

      const response = await api.post('/registrarse/checkrutcli', {
        RutCli
      });
      
      return response.data.success;

    } catch (error) {
      return false;
    }
  };

  /* Agregar Cliente */
  const handleSave = async () => {
    if (!acceptedTerms) {
      showFeedback(
        'Debe aceptar los Términos y Condiciones para continuar.',
        'warning'
      );
      return;
    }

    const validationErrors = {};
    setMessage(''); // Limpiar mensaje de error previo //

    if (!rutCli) validationErrors.rutCli = 'El Rut es obligatorio';
    if (!nombreCli) validationErrors.nombreCli = 'El Nombre es obligatorio';
    if (!direccionCli) validationErrors.direccionCli = 'La Dirección es obligatoria';
    if (!comunaCli) validationErrors.comunaCli = 'La Comuna es obligatoria';
    if (!ciudadCli) validationErrors.ciudadCli = 'La Ciudad es obligatoria';
    if (!telefonoCli) validationErrors.telefonoCli = 'El Teléfono es obligatorio';
    if (!emailCli) validationErrors.emailCli = 'El Email es obligatorio';

    if (banco1Cli) {
      if (!ctacte1Cli) {
        validationErrors.ctacte1Cli = 'Debe ingresar Ctacte 1';
      }
    }
    if (ctacte1Cli) {
      if (!banco1Cli) {
        validationErrors.banco1Cli = 'Debe seleccionar el Banco 1';
      }
    }

    if (banco2Cli) {
      if (!ctacte2Cli) {
        validationErrors.ctacte2Cli = 'Debe ingresar Ctacte 2';
      }
    }
    if (ctacte2Cli) {
      if (!banco2Cli) {
        validationErrors.banco2Cli = 'Debe seleccionar el Banco 2';
      }
    }

    if (banco3Cli) {
      if (!ctacte3Cli) {
        validationErrors.ctacte3Cli = 'Debe ingresar Ctacte 3';
      }
    }
    if (ctacte3Cli) {
      if (!banco3Cli) {
        validationErrors.banco3Cli = 'Debe seleccionar el Banco 3';
      }
    }

    /* Validación de formato de email */
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailCli && !emailRegex.test(emailCli)) {
      validationErrors.emailCli = 'El Email no es válido';
    }
    
    if (!validarRut(rutCli)) {
      validationErrors.rutCli = 'El Rut no es válido';
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const fixRutCli = normalizeRut(rutCli);
    const upperNombreCli = nombreCli.toUpperCase();
    const upperDireccionCli = direccionCli.toUpperCase();
    const upperComunaCli = comunaCli.toUpperCase();
    const upperCiudadCli = ciudadCli.toUpperCase();
    const lowerEmailCli = emailCli.toLowerCase();

    /* agregar registro */
    try {
      /* Verificar si el RUT ya existe en la base de datos */
      const rutExists = await checkRutExists(fixRutCli);

      if (rutExists) {
        setMessage('Cliente Ya Existe.');
        setErrors({});
        return;
      }

      await api.post('registrarse/addcliente', {
        rut_cli: fixRutCli,
        nombre_cli: upperNombreCli,
        direccion_cli: upperDireccionCli,
        comuna_cli: upperComunaCli,
        ciudad_cli: upperCiudadCli,
        telefono_cli: telefonoCli,
        email_cli: lowerEmailCli,
        clavesii_cli: clavesiiCli,
        claveunica_cli: claveunicaCli,
        banco1_cli: banco1Cli,
        ctacte1_cli: ctacte1Cli,
        banco2_cli: banco2Cli,
        ctacte2_cli: ctacte2Cli,
        banco3_cli: banco3Cli,
        ctacte3_cli: ctacte3Cli,
        uniqueId
      });

      onSuccess(); // 👈 avisa éxito al padre Login.jsx

    } catch (error) {
      showFeedback(
        'Hubo un problema al procesar la solicitud, intente mas tarde.',
        'error'
      );
    }
  };

  /* Abrir Modal para Crear Cliente */
  const handleAdd = () => {
    setRutCli('');
    setNombreCli('');
    setDireccionCli('');
    setComunaCli('');
    setCiudadCli('');
    setTelefonoCli('');
    setEmailCli('');
    setClavesiiCli('');
    setClaveunicaCli('');
    setBanco1Cli('');
    setCtacte1Cli('');
    setBanco2Cli('');
    setCtacte2Cli('');
    setBanco3Cli('');
    setCtacte3Cli('');
    setMessage('');

    /* Limpiar el error de todos los input */
    setErrors(prevErrors => ({
      ...prevErrors,
      rutCli: '',
      nombreCli: '',
      direccionCli: '',
      comunaCli: '',
      ciudadCli: '',
      telefonoCli: '',
      emailCli: '',
      banco1Cli: '',
      ctacte1Cli: '',
      banco2Cli: '',
      ctacte2Cli: '',
      banco3Cli: '',
      ctacte3Cli: ''
    }));
  };

  /* estado para cerrar el modal */
  const handleCloseModal = () => {
    setOpen(false);
    if (onClose) onClose(); // avisa al padre Login.jsx que se cerró el modal
  };

  /* 👉 al abrir modal, enfocar en RUT */
  useEffect(() => {
    if (open && rutInputRef.current) {
      handleAdd();
      rutInputRef.current.focus();
    }
  }, [open]);



  /* render de los datos */
  return (
    <div>

      {/* =====================================================
          MODAL REGISTRO CLIENTE
      ===================================================== */}

      <Modal
        open={open}
        disableEnforceFocus={false}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            handleCloseModal();
          }
        }}
      >

        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',

            width: 760,
            maxWidth: '95vw',
            maxHeight: '92vh',

            bgcolor: 'background.paper',

            border: '1px solid',
            borderColor: 'divider',

            borderRadius: 3,

            backdropFilter: 'blur(12px)',

            boxShadow:
              '0 20px 80px rgba(0,0,0,0.45)',

            p: 2.2,

            overflowY: 'auto',
          }}
        >

          {/* HEADER */}

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 1,
            }}
          >

            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 800,
                letterSpacing: 0.4,
                color: (theme) => theme.palette.warning.main,
              }}
            >
              👤 Registro de Cliente
            </Typography>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.6,
                opacity: 0.85,
              }}
            >
              <RiVideoFill size={18} color="#F5A53D" />

              <Typography
                variant="caption"
                sx={{
                  fontWeight: 700,
                  letterSpacing: 0.4,
                  color: 'text.secondary',
                }}
              >
                OverWatch
              </Typography>
            </Box>
          </Box>

          <Divider sx={{ my: 1.25, opacity: 0.5 }} />

          {/* ERROR */}

          {message && (
            <Box
              sx={{
                mb: 1.5,
                px: 1.5,
                py: 1,
                borderRadius: 2,

                backgroundColor: (theme) =>
                  alpha(theme.palette.error.main, 0.08),

                border: (theme) =>
                  `1px solid ${alpha(theme.palette.error.main, 0.25)}`,
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  color: 'error.main',
                  fontWeight: 700,
                  display: 'block',
                  textAlign: 'center',
                }}
              >
                {message}
              </Typography>
            </Box>
          )}

          {/* =========================================
              RUT + RAZON SOCIAL
          ========================================= */}

          <Box
            sx={{
              display: 'flex',
              gap: 1.5,
              alignItems: 'flex-start',
            }}
          >

            {/* RUT */}

            <TextField
              label="Rut"
              placeholder="Rut"
              value={rutCli}
              onChange={(e) => handleInputChange(e, 'rutCli')}
              onBlur={(e) => handleInputChange(e, 'rutCli')}
              error={Boolean(errors.rutCli)}
              helperText={errors.rutCli}
              autoComplete="off"
              autoFocus
              sx={{
                ...inputSx,

                width: 170,
                flexShrink: 0,

                '& .MuiFormHelperText-root': {
                  marginLeft: 0,
                  minHeight: 16,
                  fontSize: '0.70rem',
                },
              }}
            />

            {/* RAZON SOCIAL */}

            <TextField
              label="Razón Social"
              placeholder="Ingrese la Razón Social"
              value={nombreCli}
              onChange={(e) => handleInputChange(e, 'nombreCli')}
              fullWidth
              error={Boolean(errors.nombreCli)}
              helperText={errors.nombreCli}
              autoComplete="off"
              sx={inputSx}
            />
          </Box>

          {/* DIRECCION */}

          <TextField
            label="Dirección"
            placeholder="Ingrese la Dirección"
            value={direccionCli}
            onChange={(e) => handleInputChange(e, 'direccionCli')}
            fullWidth
            error={Boolean(errors.direccionCli)}
            helperText={errors.direccionCli}
            autoComplete="off"
            sx={inputSx}
          />

          {/* COMUNA + CIUDAD */}

          <Box
            sx={{
              display: 'flex',
              gap: 1.5,
              alignItems: 'flex-start',
            }}
          >

            <Box sx={{ flex: 1 }}>
              <TextField
                label="Comuna"
                placeholder="Ingrese la comuna"
                value={comunaCli}
                onChange={(e) => handleInputChange(e, 'comunaCli')}
                fullWidth
                error={Boolean(errors.comunaCli)}
                helperText={errors.comunaCli}
                autoComplete="off"
                sx={inputSx}
              />
            </Box>

            <Box sx={{ flex: 1 }}>
              <TextField
                label="Ciudad"
                placeholder="Ingrese la ciudad"
                value={ciudadCli}
                onChange={(e) => handleInputChange(e, 'ciudadCli')}
                fullWidth
                error={Boolean(errors.ciudadCli)}
                helperText={errors.ciudadCli}
                autoComplete="off"
                sx={inputSx}
              />
            </Box>
          </Box>

          {/* TELEFONO + EMAIL */}

          <Box
            sx={{
              display: 'flex',
              gap: 1.5,
              alignItems: 'flex-start',
            }}
          >

            <Box sx={{ width: 180 }}>
              <TextField
                label="Teléfono"
                placeholder="Teléfono"
                value={telefonoCli}
                onChange={(e) => handleInputChange(e, 'telefonoCli')}
                fullWidth
                error={Boolean(errors.telefonoCli)}
                helperText={errors.telefonoCli}
                autoComplete="off"
                sx={inputSx}
              />
            </Box>

            <Box sx={{ flex: 1 }}>
              <TextField
                label="Email"
                placeholder="Ingrese el Email"
                value={emailCli}
                onChange={(e) => handleInputChange(e, 'emailCli')}
                fullWidth
                error={Boolean(errors.emailCli)}
                helperText={errors.emailCli}
                autoComplete="off"
                sx={inputSx}
              />
            </Box>
          </Box>

          <Divider sx={{ my: 1.4, opacity: 0.5 }} />

          {/* CLAVES */}

          <Box
            sx={{
              display: 'flex',
              gap: 1.5,
              alignItems: 'flex-start',
            }}
          >

            <Box sx={{ flex: 1 }}>
              <TextField
                label="Clave SII"
                placeholder="Ingrese la Clave SII"
                value={clavesiiCli}
                onChange={(e) => handleInputChange(e, 'clavesiiCli')}
                fullWidth
                error={Boolean(errors.clavesiiCli)}
                helperText={errors.clavesiiCli}
                autoComplete="off"
                sx={inputSx}
              />
            </Box>

            <Box sx={{ flex: 1 }}>
              <TextField
                label="Clave Única"
                placeholder="Ingrese la Clave Única"
                value={claveunicaCli}
                onChange={(e) => handleInputChange(e, 'claveunicaCli')}
                fullWidth
                error={Boolean(errors.claveunicaCli)}
                helperText={errors.claveunicaCli}
                autoComplete="off"
                sx={inputSx}
              />
            </Box>
          </Box>

          {/* BANCOS */}

          <Box
            sx={{
              display: 'flex',
              gap: 1.5,
              alignItems: 'flex-start',
            }}
          >

            {[1, 2, 3].map((num) => {

              const bancoValue =
                num === 1 ? banco1Cli :
                num === 2 ? banco2Cli :
                banco3Cli;

              const bancoError =
                num === 1 ? errors.banco1Cli :
                num === 2 ? errors.banco2Cli :
                errors.banco3Cli;

              return (
                <Box key={num} sx={{ flex: 1 }}>

                  <FormControl
                    fullWidth
                    error={Boolean(bancoError)}
                    sx={inputSx}
                  >

                    <Select
                      value={bancoValue}
                      displayEmpty
                      onChange={(e) =>
                        handleInputChange(
                          e,
                          `banco${num}Cli`
                        )
                      }
                      sx={{
                        height: 38,
                        fontSize: '0.84rem',
                        borderRadius: 2,
                        color: bancoValue
                          ? 'white'
                          : 'text.secondary',
                      }}
                    >

                      <MenuItem value="">
                        <Typography
                          variant="caption"
                          sx={{
                            color: (theme) =>
                              theme.palette.warning.light,
                          }}
                        >
                          ✨ Banco {num}
                        </Typography>
                      </MenuItem>

                      {bancos.map((banco) => (
                        <MenuItem
                          key={banco.id}
                          value={String(banco.id)}
                        >
                          {banco.nomban}
                        </MenuItem>
                      ))}

                    </Select>

                    {bancoError && (
                      <FormHelperText>
                        {bancoError}
                      </FormHelperText>
                    )}

                  </FormControl>

                </Box>
              );
            })}
          </Box>

          {/* CUENTAS */}

          <Box
            sx={{
              display: 'flex',
              gap: 1.5,
              alignItems: 'flex-start',
            }}
          >

            {[1, 2, 3].map((num) => {

              const value =
                num === 1 ? ctacte1Cli :
                num === 2 ? ctacte2Cli :
                ctacte3Cli;

              const error =
                num === 1 ? errors.ctacte1Cli :
                num === 2 ? errors.ctacte2Cli :
                errors.ctacte3Cli;

              return (
                <Box key={num} sx={{ flex: 1 }}>

                  <TextField
                    label={`Ctacte ${num}`}
                    value={value}
                    onChange={(e) =>
                      handleInputChange(
                        e,
                        `ctacte${num}Cli`
                      )
                    }
                    fullWidth
                    error={Boolean(error)}
                    helperText={error}
                    autoComplete="off"
                    sx={inputSx}
                  />

                </Box>
              );
            })}
          </Box>

          {/* TERMINOS */}

          <Box
            sx={{
              mt: 1,

              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',

              gap: 1,
            }}
          >

            <FormControlLabel
              sx={{
                margin: 0,

                '.MuiCheckbox-root': {
                  padding: '4px',
                },
              }}
              control={
                <Checkbox
                  checked={acceptedTerms}
                  onChange={(e) =>
                    setAcceptedTerms(
                      e.target.checked
                    )
                  }
                  size="small"
                  color="warning"
                />
              }
              label={
                <Typography
                  variant="caption"
                  sx={{
                    lineHeight: 1.4,
                    color: 'text.secondary',
                  }}
                >
                  Acepto los{' '}

                  <Link
                    component="button"
                    underline="hover"
                    sx={{
                      fontWeight: 700,
                      color: '#60A5FA',
                      cursor: 'pointer',
                      fontSize: '0.78rem',

                      transition: 'all 0.2s ease',

                      '&:hover': {
                        color: '#93C5FD',
                      },
                    }}
                    onClick={() => setOpenTerms(true)}
                  >
                    Términos y Condiciones
                  </Link>
                </Typography>
              }
            />

            {/* BOTONES */}

            <Box
              sx={{
                display: 'flex',
                gap: 1,
              }}
            >

              <Button
                variant="contained"
                color="warning"
                disabled={
                  !acceptedTerms ||
                  !isFormValid
                }
                startIcon={<RiSave3Fill />}
                onClick={handleSave}
                sx={{
                  textTransform: 'none',
                  fontWeight: 700,
                  borderRadius: 2,
                  px: 2,
                  py: 0.7,
                  fontSize: '0.82rem',
                }}
              >
                Grabar
              </Button>

              <Button
                variant="outlined"
                color="inherit"
                startIcon={<RiReplyAllLine />}
                onClick={handleCloseModal}
                sx={{
                  textTransform: 'none',
                  borderRadius: 2,
                  px: 2,
                  py: 0.7,
                  fontSize: '0.82rem',
                }}
              >
                Cancelar
              </Button>

            </Box>
          </Box>
        </Box>
      </Modal>

      {/* =====================================================
          MODAL TERMINOS Y CONDICIONES
      ===================================================== */}

      <Modal
        open={openTerms}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            setOpenTerms(false);
          }
        }}
      >

        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',

            width: 720,
            maxWidth: '95vw',
            maxHeight: '92vh',

            bgcolor: 'rgba(18,18,20,0.94)',

            border: '1px solid rgba(255,255,255,0.08)',

            borderRadius: 4,

            backdropFilter: 'blur(20px)',

            boxShadow:
              '0 30px 120px rgba(0,0,0,0.65)',

            p: 3,

            overflowY: 'auto',
          }}
        >

          {/* =====================================================
              HEADER
          ===================================================== */}

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 1,
            }}
          >

            <Box>

              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 800,
                  letterSpacing: 0.4,
                  color: '#F5A53D',
                }}
              >
                Términos y Condiciones
              </Typography>

              <Typography
                variant="caption"
                sx={{
                  color: 'rgba(255,255,255,0.48)',
                  fontSize: '0.74rem',
                  letterSpacing: 0.2,
                }}
              >
                Plataforma OverWatch
              </Typography>

            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.7,
                opacity: 0.6,
              }}
            >
              <RiVideoFill size={18} color="#F5A53D" />

              <Typography
                variant="caption"
                sx={{
                  fontWeight: 700,
                  letterSpacing: 0.4,
                  color: 'rgba(255,255,255,0.7)',
                }}
              >
                OverWatch
              </Typography>
            </Box>
          </Box>

          <Divider
            sx={{
              my: 1.6,
              borderColor: 'rgba(255,255,255,0.08)',
            }}
          />

          {/* =====================================================
              INTRO
          ===================================================== */}

          <Typography
            variant="body2"
            sx={{
              mb: 2.5,

              color: 'rgba(255,255,255,0.62)',

              lineHeight: 1.8,

              fontSize: '0.82rem',
            }}
          >
            Antes de utilizar la plataforma, le recomendamos leer
            atentamente las siguientes condiciones relacionadas
            con el uso, seguridad y tratamiento de la información.
          </Typography>

          {/* =====================================================
              BLOQUES
          ===================================================== */}

          {[
            {
              title: 'Confidencialidad y Seguridad',
              text:
                'La información entregada será tratada de forma confidencial y protegida mediante medidas de seguridad adecuadas.',
            },
            {
              title: 'Protección de Datos Personales',
              text:
                'Los datos serán utilizados únicamente para fines relacionados con el funcionamiento de la plataforma.',
            },
            {
              title: 'Buen Uso de la Aplicación',
              text:
                'El usuario se compromete a utilizar la plataforma de manera responsable y conforme a la normativa vigente.',
            },
            {
              title: 'Responsabilidad del Usuario',
              text:
                'Cada usuario es responsable de la veracidad de los datos proporcionados y del uso de sus credenciales.',
            },
            {
              title: 'Responsabilidad del Propietario',
              text:
                'El propietario velará por la seguridad y disponibilidad razonable del servicio.',
            },
            {
              title: 'Propiedad Intelectual',
              text:
                'La plataforma y sus contenidos están protegidos por las leyes de propiedad intelectual.',
            },
            {
              title: 'Modificaciones',
              text:
                'Los términos podrán actualizarse periódicamente notificando oportunamente a los usuarios.',
            },
          ].map((item) => (
            <Box
              key={item.title}
              sx={{
                mb: 1.6,

                p: 1.5,

                borderRadius: 2.5,

                background:
                  'rgba(255,255,255,0.025)',

                border:
                  '1px solid rgba(255,255,255,0.05)',

                transition: 'all 0.2s ease',

                '&:hover': {
                  background:
                    'rgba(255,255,255,0.04)',

                  border:
                    '1px solid rgba(255,255,255,0.08)',
                },
              }}
            >

              <Typography
                variant="caption"
                sx={{
                  display: 'block',

                  fontWeight: 700,

                  fontSize: '0.82rem',

                  mb: 0.6,

                  color: 'rgba(255,255,255,0.92)',

                  letterSpacing: 0.2,
                }}
              >
                {item.title}
              </Typography>

              <Typography
                variant="caption"
                sx={{
                  display: 'block',

                  fontSize: '0.78rem',

                  lineHeight: 1.8,

                  color: 'rgba(255,255,255,0.62)',
                }}
              >
                {item.text}
              </Typography>

            </Box>
          ))}

          <Divider
            sx={{
              my: 1.8,
              borderColor: 'rgba(255,255,255,0.08)',
            }}
          />

          {/* =====================================================
              FOOTER
          ===================================================== */}

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 2,
            }}
          >

            <Typography
              variant="caption"
              sx={{
                color: 'rgba(255,255,255,0.42)',
                fontSize: '0.72rem',
              }}
            >
              Última actualización · Mayo 2026
            </Typography>

            <Button
              variant="outlined"
              color="warning"
              onClick={() => setOpenTerms(false)}
              sx={{
                textTransform: 'none',

                borderRadius: 2.5,

                px: 2.5,
                py: 0.7,

                fontSize: '0.82rem',

                fontWeight: 700,

                borderWidth: 1.5,

                '&:hover': {
                  borderWidth: 1.5,
                },
              }}
            >
              Cerrar
            </Button>

          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default Registrarcliente;
